
import Patient                                      from './Patient'

import BookingData                                  from './BookingData'

/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
const BookingSummary = ({booking}) => {
    
    const bookD = booking? new BookingData( booking ): null
    
    return <>
        {booking?
        <div>
        <BookingHeading booking={bookD} />
        {!bookD.confirmed? <p><em>Booking not completed</em>. This booking will automatically be deleted if the booking process is not completed.</p>:null}
        { bookD.patient? <Patient patientRecord={bookD} />: '' }
        <br/>
        <dl><dt>Start Time</dt><dd>{bookD.getStartString()}</dd><dt>End Time</dt><dd>{bookD.getEndString()}</dd></dl>
        <dl><dt>Clinician</dt><dd>{bookD.clinician.name}</dd></dl>
        { bookD.appointmentType? <dl><dt>AppointmentType</dt><dd>{bookD.appointmentType.title}</dd></dl>: '' }
        <h2>Booking Description</h2>
        <em>This is not part of the patient record.</em>
        <p>{booking.description? booking.description: 'Nothing recorded'}</p>
        {
            bookD.isApptWithin5Days ? '' :
            <div>
            <h2>Reason appointment is outside 5 working days</h2>
            <p>{booking.apptTimeExplanation? booking.apptTimeExplanation: 'Nothing recorded'}</p>
            </div>
        }
    </div>: ''}</>
}

const BookingHeading = ({booking}) => {
    
    if( !(booking instanceof BookingData) ){
        throw new Error('Not right type');
    }
    
    const patient = booking.patient

    
    return  <h2>Booking for {patient.firstName} {patient.lastName} {'(' + booking.client.name + ')'}</h2>
}

export {BookingHeading} 
export default              BookingSummary;